import QueueManage from './queue_manage.vue';

export default QueueManage;
